import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import {
	LegalList,
	LegalPageLayout,
	LegalSection,
} from "#/components/legal/LegalPageLayout";

export const Route = createFileRoute("/terms")({
	component: TermsPage,
});

function TermsPage() {
	const { t } = useTranslation("legal");
	const rawT = t as unknown as (key: string, opts: object) => string[];
	const tList = (key: string) => rawT(key, { returnObjects: true });

	return (
		<LegalPageLayout
			tag={t("terms.tag")}
			title={t("terms.title")}
			updated={t("terms.updated")}
		>
			<p className="text-sm leading-relaxed text-muted-foreground">
				{t("terms.intro")}
			</p>

			<LegalSection heading={t("terms.service.heading")}>
				<p>{t("terms.service.body")}</p>
			</LegalSection>

			<LegalSection heading={t("terms.eligibility.heading")}>
				<p>{t("terms.eligibility.body")}</p>
			</LegalSection>

			<LegalSection heading={t("terms.accounts.heading")}>
				<p>{t("terms.accounts.body")}</p>
			</LegalSection>

			<LegalSection heading={t("terms.listings.heading")}>
				<p>{t("terms.listings.intro")}</p>
				<LegalList items={tList("terms.listings.items")} />
				<p>{t("terms.listings.outro")}</p>
			</LegalSection>

			<LegalSection heading={t("terms.transactions.heading")}>
				<p>{t("terms.transactions.body")}</p>
			</LegalSection>

			<LegalSection heading={t("terms.content.heading")}>
				<p>{t("terms.content.body")}</p>
			</LegalSection>

			<LegalSection heading={t("terms.disclaimer.heading")}>
				<p>{t("terms.disclaimer.body")}</p>
			</LegalSection>

			<LegalSection heading={t("terms.termination.heading")}>
				<p>{t("terms.termination.body")}</p>
			</LegalSection>

			<LegalSection heading={t("terms.law.heading")}>
				<p>{t("terms.law.body")}</p>
			</LegalSection>

			<LegalSection heading={t("terms.changes.heading")}>
				<p>{t("terms.changes.body")}</p>
			</LegalSection>

			<LegalSection heading={t("terms.contact.heading")}>
				<p>{t("terms.contact.body")}</p>
			</LegalSection>
		</LegalPageLayout>
	);
}
